import script from "./Html-Block.vue?vue&type=script&setup=true&lang=js"
export * from "./Html-Block.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__